<div class="row" *ngIf="isComercial">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>

                <mat-card-content *ngIf="!collapseCard">

                    <div class="row pt-3">
                        <div class="col-lg-6 col-md-6">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Controle de Análise (ET004)</mat-label>
                                <input matInput id="txtControleAnaliseEt004" #txtControleAnaliseEt004 maxlength="10"
                                    formControlName="controle_analise_et004" (blur)="getDataEt004()"
                                    (blur)="makeCalculations()" currencyMask
                                    [options]="{ thousands: '.', decimal: ',', precision: 0 }">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-hint align="end">{{txtControleAnaliseEt004.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.controle_analise_et004)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Linha 1 -->

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Início Tratamento Data</mat-label>
                                <input matInput id="txtIniTratamentoData" #txtIniTratamentoData maxlength="10"
                                    mask="d0/M0/0000" formControlName="inicio_tratamento_data" [readonly]="true"
                                    class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtIniTratamentoData.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.inicio_tratamento_data)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Início Tratamento Hora</mat-label>
                                <input matInput id="txtIniTratamentoHora" #txtIniTratamentoHora maxlength="5"
                                    mask="Hh:m0" formControlName="inicio_tratamento_hora" [readonly]="true"
                                    class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtIniTratamentoHora.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.inicio_tratamento_hora)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Linha 2 -->

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Término Tratamento Data</mat-label>
                                <input matInput id="txtTerTratamentoData" #txtTerTratamentoData maxlength="10"
                                    mask="d0/M0/0000" formControlName="termino_tratamento_data" [readonly]="true"
                                    class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtTerTratamentoData.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.termino_tratamento_data)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Término Tratamento Hora</mat-label>
                                <input matInput id="txtTerTratamentoHora" #txtTerTratamentoHora maxlength="5"
                                    mask="Hh:m0" formControlName="termino_tratamento_hora" [readonly]="true"
                                    class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                    {{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtTerTratamentoHora.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.termino_tratamento_hora)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Linha 3 -->

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Tipo de Tratamento</mat-label>
                                <input matInput id="txtTipoTratamento" #txtTipoTratamento maxlength="50"
                                    formControlName="tipo_tratamento" [readonly]="true" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtTipoTratamento.value.length}} / 50</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.tipo_tratamento)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Duração da Atividade de Tratamento (h)</mat-label>
                                <input matInput id="txtDuracaoAtividadeTratamento" #txtDuracaoAtividadeTratamento
                                    maxlength="20" formControlName="duracao_atividade_tratamento_h" currencyMask
                                    [readonly]="true" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtDuracaoAtividadeTratamento.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.duracao_atividade_tratamento_h)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>
